export default "__VITE_ASSET__BjhzkHnE__"